<section class="pt-0 pb-0">
    <ngx-spinner></ngx-spinner>
<section class="casestudy-no-bg comman-page interview-page-detail pt-0 overflow-visible mt-110 pb-280">
	<div class="container">
		<div class="inner-container min-h-600">
			<div class="row cs-toprow mb-3 align-items-center">
				<div class="col-md-6 cs-left">
					<div class="post-date" *ngIf="interviewDetails?.publish_date">
						<!-- (March 30, 2020 12:00 AM) -->
						({{interviewDetails?.publish_date | date:'fullDate' | uppercase}})
					</div>
					<h2 class="page-title pl-0 mt-0 pt-0">{{interviewDetails?.title}}</h2>
				</div>
				<div class="col-md-6 cs-right tags text-right" *ngIf="interviewDetails?.tags && interviewDetails?.tags.length > 0">
					<span  *ngFor="let tag of  interviewDetails?.tags | slice:0:5" (click)="searcRoute(tag)">
					<a class="btn btn-default blue-btn rounded-pill text-white">#{{tag}}</a>
				</span>

				</div>
			</div>
					<!-- SIMPLE SLICK FOR 2 IMAGES -->
					<div id="demo" class="carousel slide hero-slider casestudy-banner mt-0" *ngIf="interviewDetails?.images.length == 2 else mainSlickNormal" data-ride="carousel">
						<div class="container">
							<div class="carousel carousel-inner  art mb-0 banner-placeholder">
								<ngx-slick class="carousel slider-for" #slickModal="slick-modal" [config]="slideConfigMainBannerWithTwoImages">
									<div ngxSlickItem *ngFor="let data of sliderImages" class="slide">
										<img [src]="imageBasePath + data" alt="first slide" style="display: block; width: 100%;">
										<div class="carousel-caption d-none d-md-block text-left">
											<!-- <h3>{{data?.title}}</h3> -->
											<!-- <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p> -->
										</div>
									</div>
								</ngx-slick>
							</div>
						</div>
					</div>
			<ng-template #mainSlickNormal>
			<div id="demo" class="carousel slide hero-slider casestudy-banner mt-0" *ngIf="interviewDetails?.images.length > 0" data-ride="carousel">
				<div class="container">
					<div class="carousel carousel-inner  art mb-0 banner-placeholder">
						<ngx-slick class="carousel slider-for" #slickModal="slick-modal" [config]="slideConfigMainBanner">
							<div ngxSlickItem *ngFor="let data of sliderImages" class="slide">
								<img [src]="imageBasePath + data" alt="first slide" style="display: block; width: 100%;">
								<div class="carousel-caption d-none d-md-block text-left">
									<!-- <h3>{{data?.title}}</h3> -->
									<!-- <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p> -->
								</div>
							</div>
						</ngx-slick>
					</div>
				</div>
			</div>
		</ng-template>
			<div id="demo" class="carousel slide hero-slider casestudy-banner thumb-slider mt-3" *ngIf="interviewDetails?.images.length > 2" data-ride="carousel">
				<div class="container">
					<div class="carousel carousel-inner  art mb-0 ">
						<ngx-slick class="carousel slider-nav" #slickModal="slick-modal" [config]="slideConfigMainBannerSubImages">
							<div ngxSlickItem *ngFor="let data of sliderImages" class="slide">
								<img [src]="imageBasePath + data" alt="first slide" style="display: block; width: 100%;">
								<div class="carousel-caption d-none d-md-block text-left">
									<!-- <h3>{{data?.title}}</h3> -->
									<!-- <p><strong><span class="roboto-light">By<strong>:</strong></span> {{data?.author}}</strong></p> -->
								</div>
							</div>
						</ngx-slick>
					</div>
				</div>
			</div>
			<!--Carousel Wrapper-->
			<!-- <div id="carousel-thumb" class="carousel slide carousel-fade carousel-thumbnails" data-ride="carousel">
				<div class="carousel-inner" role="listbox" *ngIf="interviewDetails">
					<div class="carousel-item active">
						<img class="d-block w-100" [src]="imageBasePath + mainImg" alt="">
					</div> -->
					<!-- <div class="carousel-item" *ngFor="let data of interviewDetails.images">
						<img class="d-block w-100" [src]="imageBasePath + data" alt="">
					</div> -->

				<!-- </div> -->
				<!--/.Slides-->
				<!--Controls-->
				<!-- <a class="carousel-control-prev" href="#carousel-thumb" role="button" data-slide="prev">
					<span class="carousel-control-prev-icon" aria-hidden="true"></span>
					<span class="sr-only">Previous</span>
				</a>
				<a class="carousel-control-next" href="#carousel-thumb" role="button" data-slide="next">
					<span class="carousel-control-next-icon" aria-hidden="true"></span>
					<span class="sr-only">Next</span>
				</a> -->
				<!-- <ol class="carousel-indicators relative" *ngIf="interviewDetails">
					<li data-target="#carousel-thumb" data-slide-to="0" *ngFor="let data of sliderImages; let i=index">
						 <img class="d-block w-100"
						 [src]="imageBasePath + data" (click)="selectImg(data)" class="img-fluid">
						</li>
				</ol>
			</div> -->
			<!--/.Carousel Wrapper-->

			<div class="details-bottom mt-5 relative">
				<div class="share-div">
					<p>Share this on</p>
					<!-- <share-buttons [theme]="'circles-dark'"
                    [include]="['facebook','twitter','linkedin']"
                    [show]="3"
                    [size]="-6"
                    [url]='encodeSocialURI(currentUrl)'
                    [autoSetMeta]="true"
                    [title]="interviewDetails?.title"
                    [description]="interviewDetails?.title"
				></share-buttons> -->
				<ul class="share-now d-flex">
					<li><a href="https://www.facebook.com/sharer.php?t={{interviewDetails?.title}}&u={{socialShareUrl}}" target="_blank"><img src="assets/img/case-study/share-icon3.png" alt=""></a></li>
					<li><a href="https://www.linkedin.com/sharing/share-offsite/?url={{socialShareUrl}}" target="_blank"><img src="assets/img/case-study/share-icon5.png" alt=""></a></li>
					<li><a href="https://twitter.com/intent/tweet?url={{socialShareUrl}}&text={{interviewDetails?.title}}" target="_blank"><img src="assets/img/case-study/share-icon6.png" alt=""></a></li>
				</ul>
	   <!-- <ul class="share-now d-flex">
		<li><a [attr.href]="'https://'+encodeSocialURI(interviewDetails?.title, 'facebook')" target="_blank"><img src="assets/img/case-study/share-icon3.png" alt=""></a></li>
		<li><a [attr.href]="'https://'+encodeSocialURI(interviewDetails?.title, 'linkedin')" target="_blank"><img src="assets/img/case-study/share-icon5.png" alt=""></a></li>
		<li><a [attr.href]="'https://'+encodeSocialURI(interviewDetails?.title, 'twitter')" target="_blank"><img src="assets/img/case-study/share-icon6.png" alt=""></a></li>
		<li><a href="https://instagram.com/socialapphub?igshid=9foj2xxzn44z" target="_blank"><img src="assets/img/ins-share.png" alt=""></a></li>
	</ul> -->
				</div>
				<div class="row">
					<div class="col-md-8 detail-b-left pt-2">
						<div class="wrap">
							<div id="tabs">
								<div class="container">
									<div class="row">
										<div class="col-sm-12">
											<div class="tab-content pb-5 pt-0 px-3 px-sm-0" id="nav-tabContent">
												<div class="tab-pane fade show active" id="nav-home" role="tabpanel"
													aria-labelledby="nav-home-tab">
													<div class="col-md-6 cs-left" *ngIf="interviewDetails?.author_name">
														<p><strong><span class="roboto-light">By<strong>: </strong></span> <i>{{interviewDetails?.author_name}}</i></strong></p>
													</div>
													<div class="abt-pannel d-flex">
														<div class="abt-img" *ngIf='interviewDetails'>
															<img [src]="imageBasePath + interviewDetails?.candidate_image" alt="">
														</div>
														<div class="abt-content">
															<h3 [innerHtml]="transform1(interviewDetails?.candidate_description)"></h3>
															<p>{{interviewDetails?.candidate_name}}</p>
														</div>
													</div>
													<span [innerHtml]="transform1(interviewDetails?.description)"></span>
												</div>
											</div>

										</div>
									</div>
								</div>
							</div>


						</div>
					</div>
					<!-- left side end-->
					<div class="col-md-4 related-case-study pt-100">
						<div class="wrap">
							<h3 class="font22 font-semi font-color3 mb-3">Related Interviews</h3>
							<!-- <div class="carousel art mb-0 carousel-inner realted-col">
								<ngx-slick class="carousel" #slickModal="slick-modal" [config]="similarAppSliderConfig">
									<div ngxSlickItem *ngFor="let data of relatedInterviewDetails" class="slide"> -->
										<div class="realted-col" *ngFor="let data of relatedInterviewDetails">
										<div class="case-thumb"><img [src]="imageBasePath + data?.images[0]" alt=""></div>
								<div class="case-deta">
									<h4 [innerHtml]="transform(data?.title,30)">
										<!-- {{data?.title}} -->
									</h4>
									<p [innerHtml]="transform(data?.description,40)">
										<!-- {{ (data.description.length > 40) ? (data.description | slice:0:40 | safeHtml) + '...' : data.description }}... -->
									</p>
									<a (click)="relatedInterviewDetail(data)" class="btn btn-primary rounded-pill">More</a>
								</div>
									</div>
								<!-- </ngx-slick>
							</div> -->
							<!-- <div class="realted-col" *ngFor="let data of relatedInterviewDetails">
								<div class="case-thumb"><img [src]="imageBasePath + data?.images[0]" alt=""></div>
								<div class="case-deta">
									<h4>{{data?.title}}</h4>
									<p> {{ (data.description.length > 100) ? (data.description | slice:0:100 | safeHtml) + '...' : data.description }}...</p>
									<a [routerLink]="['/knowledge-section/interview/detail',data?._id]" class="btn btn-primary rounded-pill">More</a>
								</div>
							</div> -->
						</div>
					</div><!-- related-case-study end -->


				</div>

			</div><!-- details-bottom end -->



		</div>
	</div>
</section>
</section>


<ng-template #template>
	<div class="modal-body text-center">
	  <h4>Coming Soon .......</h4>
  </div>
  <div class="modal-footer text-center">
	  <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Close</button>
  </div>
  </ng-template>
